<script setup lang="ts">
import BaseSticker from "@/components/ui/BaseSticker/BaseSticker.vue";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { Sticker } from "@/model/StickerType";

defineProps<{ stickers: Array<Sticker | null> }>();
</script>

<template>
  {{ $t("general.stickers") }}
  <div>
    <template
      v-for="sticker in stickers"
      :key="sticker ? `${sticker.icon}-${sticker.color}` : 'none'"
    >
      <div class="stickers">
        <BaseSticker v-if="sticker" :sticker />
        <SvgIcon v-else name="general/sticker" width="20" height="20" />
      </div>
    </template>
  </div>
</template>

<style lang="scss">
.stickers {
  height: 30px;
  display: inline-block;
}
</style>
